import React, { useState } from 'react';

const EventIcon = ({
  event_id,
  event_icon,
  event_image,
  event_theme_color,
  icon_width = '100%',
  icon_height = '100%',
  multiple,
  hide_border
}) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  if (event_image) {
    return (
      <div className='event-icon'>
        <img
          className={`${multiple ? 'multiple-card-image' : 'card-image'}`}
          style={{
            border: `2.5px solid ${(event_theme_color && !hide_border) ? event_theme_color : 'transparent'}`,
            borderRadius: `100%`,
            width: icon_width ? icon_width :'100%',
            height: icon_height ? icon_height :'100%',
            objectFit: 'cover'
          }}
          src={ imgLoaded ? event_image : event_icon?.url ? event_icon.url : event_image}
          alt='Event Icon'
          onLoad={() => setImgLoaded(true)}
        />
      </div>
    );
  }

  const event_icon_content = event_icon?.content?.replace(
    '<svg',
    `<svg id="event-icon-${event_id}"`,
  );
  return (
    <>
    <div>
      <div
        className='event-icon'
        dangerouslySetInnerHTML={{ __html: event_icon_content }}
      />
      <style>
        {`svg#event-icon-${event_id} {
          width: ${icon_width || '100%'};
          height: ${icon_height || '100%'};
          color: ${event_theme_color || '#333'};
        }`}
      </style>
      </div>

    
    </>
  );
};

export default EventIcon;
